module.exports = __webpack_public_path__ + "img/first-pass-box.b4478e43.svg";